import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { authAPI } from '../../utils/api';

const AdminLogin = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await authAPI.login(data);
      localStorage.setItem('admin_token', response.data.access_token);
      localStorage.setItem('admin_user', JSON.stringify(response.data.user));
      toast.success('Login successful');
      navigate('/admin');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-16 w-16 flex items-center justify-center rounded-full bg-primary">
            <Lock className="h-8 w-8 text-white" />
          </div>
          <h2 className="mt-6 text-4xl font-bold text-primary">
            {t('login')}
          </h2>
          <p className="mt-2 text-sm text-muted-foreground">
            Admin Dashboard Access
          </p>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="mt-8 space-y-6 bg-white p-8 rounded-lg shadow-sm border border-slate-200">
          <div className="space-y-4">
            <div>
              <Label htmlFor="username">Username</Label>
              <Input
                id="username"
                {...register('username', { required: true })}
                className="h-12"
                placeholder="admin"
                data-testid="admin-username-input"
              />
              {errors.username && (
                <p className="text-red-500 text-sm mt-1">Username is required</p>
              )}
            </div>

            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                {...register('password', { required: true })}
                className="h-12"
                placeholder="••••••••"
                data-testid="admin-password-input"
              />
              {errors.password && (
                <p className="text-red-500 text-sm mt-1">Password is required</p>
              )}
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-accent hover:bg-accent/90"
            data-testid="admin-login-submit-btn"
          >
            {loading ? t('pleaseWait') : t('login')}
          </Button>

          <div className="text-center text-sm text-muted-foreground">
            {/* <p>Default credentials: admin / admin123</p> */}
          </div>
        </form>

        <div className="text-center">
          <Button
            variant="ghost"
            onClick={() => navigate('/')}
            data-testid="back-to-home-btn"
          >
            ← {t('home')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;